import * as React from 'react'
import { useState } from 'react'
import { useTemperatureUnitContext } from 'context/TemperatureUnitContext'
import {useTransition, animated} from "react-spring";

export const TemperatureUnitPicker = () => {
    const [unit, dispatch] = useTemperatureUnitContext()
    const [dropDownOpen, setDropDownOpen] = useState(false)

    const slideOpen = useTransition(dropDownOpen, {
        from: { maxHeight: 0 },
        enter: { maxHeight: 130 },
        leave: { maxHeight: 0 },
        config: { duration: 200 },
        delay: 0,
    })

    return (
        <>
            <div className="unit__picker">
                <div className="unit__picker--option unit__picker--default" onClick={() => setDropDownOpen((prev) => !prev)}>{`° ${unit}`}</div>
                <button
                    aria-label={'Výběr teploty'}
                    className="unit__picker--button"
                    onClick={() => setDropDownOpen((prev) => !prev)}
                />
            </div>
            {slideOpen((styles, isOpen) => isOpen && (
                <animated.div className="unit__picker--options" style={styles}>
                    <button
                        className="unit__picker--option"
                        onClick={() => {
                            dispatch({type: 'SET_DEGREE_C'})
                            setDropDownOpen(false)
                        }}
                    >
                        ° C
                    </button>
                    <button
                        className="unit__picker--option"
                        onClick={() => {
                            dispatch({type: 'SET_DEGREE_F'})
                            setDropDownOpen(false)
                        }}
                    >
                        ° F
                    </button>
                </animated.div>
            ))}
        </>
    )
}
